module.exports = __webpack_public_path__ + "static/3-b5e2fde3e8826e0e462da02a5ca881a3.gif";